const GlobalConstants = {
  COLORS: ['#0088FE', '#00C49F', '#FFBB28', 'purple', '#FF5722', 'orange'],

  CHECKING: '#4CD0D9',
  SAVINGS: '#39D78B',
  INVESTMENT: '#E9EB6F',
  CREDIT: '#FF6969',
  DEBT: '#D7F8D8',
  OTHER: '#ECECEC',
  TEXT: '#9d9db0',

  cpccCode: 'cpcc23810674',
  bcccCode: 'bccc53028742',
  wvccCode: 'wvcc28403381',
  mccCode: 'mcc46901327',

  headers: [
    'Dashboard',
    'Financial',
    'At Risk',
    'Development',
    'Profile',
    'Goals',
    'Notifications',
  ],

  products: ['dashboard', 'pfm'],
};

export default GlobalConstants;
